import { createApi } from '@reduxjs/toolkit/query/react'
import { AddressDto, SearchAddressPayload } from './address.types'
import { createBaseQueryWithReauth } from 'store/auth/base-query-with-reauth'

const baseUrl = `${process.env.REACT_APP_ONBOARDING_SERVICE_API}`

export const addressApi = createApi({
  reducerPath: 'addressApi',
  baseQuery: createBaseQueryWithReauth(baseUrl!),
  endpoints: (builder) => ({
    searchAddress: builder.query<AddressDto[], SearchAddressPayload>({
      query: ({ addressQuery }) => ({
        url: `oapi/v1/address/search`,
        params: { addressQuery },
      }),
    }),

    geocodeAddress: builder.query<AddressDto, { address: string }>({
      query: ({ address }) => ({
        url: `oapi/v1/address/geocode`,
        params: { address },
      }),
    }),
  }),
})

export const { useLazySearchAddressQuery, useLazyGeocodeAddressQuery } = addressApi

